import { TweenMax } from 'gsap';
import { Power1 } from 'gsap';
import { Power3 } from 'gsap';
import { isBreakpoint } from '@fnv-core/dom';
import { EventManager } from '@fnv-core/events';
import { PluginManager } from '@fnv-static/plugins';
import { Impetus } from '../../jslibs/impetus.js';
import { EVENT_PAGESLIDER_ITEMS_LOADED } from './constants';

/**
 * Controller for adding 'carousel-like' page slider functionality.
 * For example to scroll through horizontal news items.
 */
class PageSliderController {
  totalWidth : number;
  slideElement : string;
  slideTransform : string;
  sliderContainer : string;
  controlLeft : string;
  controlRight : string;
  useParentWidhForSlideElement : boolean;

  setTotalWidth() {
    let slideWidth : number = $(this.slideElement).outerWidth(true);
    if (!!this.useParentWidhForSlideElement) {
      slideWidth = $(this.slideElement).parent().outerWidth(true);
    }

    this.totalWidth = slideWidth * $(this.slideElement).length;
  }

  updateControlsState(currentPosition : number, maxPosition) {
    $(this.controlLeft).removeClass("disabled");
    $(this.controlRight).removeClass("disabled");
    if (currentPosition >= 0) {
      $(this.controlLeft).addClass("disabled");
    } 

    if (currentPosition <= maxPosition) {
      $(this.controlRight).addClass("disabled");
    } 
  }

  constructor(sliderContainer : string | any, 
      slideTransform : string | any, 
      slideElement : string | any, 
      controlLeft : string | any, 
      controlRight : string | any, 
      useParentWidhForSlideElement: boolean = false,
      slideOnAllBreakPoints : boolean = false) {
    if ($(slideElement).length > 0) {
      
      let currentPosition : number = 0;

      this.slideElement = slideElement;
      this.sliderContainer = sliderContainer;
      this.slideTransform = slideTransform;
      this.controlLeft = controlLeft;
      this.controlRight = controlRight;
      this.useParentWidhForSlideElement = useParentWidhForSlideElement;    

      TweenMax.to($(sliderContainer), 0.35, {opacity: 1, ease: Power1.easeInOut});

      let element : JQuery = $(slideElement);
      let containerElement : JQuery = $(slideTransform);
      let slideWidth : number = $(slideElement).outerWidth(true);
      if (!!this.useParentWidhForSlideElement) {
        slideWidth = $(slideElement).parent().outerWidth(true);
      }
      let position : number = 0;
      const startPosition : number = 0;
      this.setTotalWidth();
      let self : any = this;
      const slideControls : JQuery = $(".page-slider__slides-control");

      let ignoreImpetus : boolean = false;
      const currentSlide = 0;
      let canceled : boolean = false;
      
      TweenMax.set(slideTransform, {x: position + "px"});

      self.updateControlsState(currentPosition, Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 )));

      const myImpetus = new Impetus({
        source: $(sliderContainer)[0],
        multiplier: 1.2,
        friction: 0.93,
        boundX: [-(self.totalWidth - $(containerElement).innerWidth() - 5) , 0],
        update: function(x : number, y : number, decVelX : number, decVelY : number, decelerating : boolean) {
          if (!ignoreImpetus) {
            canceled = false;
            if (self.totalWidth < $(containerElement).innerWidth()) {
              myImpetus.pause();
              return false;
            }

            position = x;

            TweenMax.set(slideTransform, {x: position + "px"});            
          }
        },
        canceled: function() {

          //
        }
      });


      let touchEventsReceived = false;
      let startCoordinate : any = undefined;

      $(sliderContainer).on("mousedown touchstart", (event) => {

        if (!slideOnAllBreakPoints && (isBreakpoint("md") || isBreakpoint ("lg") || isBreakpoint ("xl"))) {
          
          myImpetus.pause();
          return;
        }

        myImpetus.resume();

        let coordinates : any = {};
        if (event.type === 'touchstart') {
          touchEventsReceived = true;
          const touch = event.targetTouches[0] || event.changedTouches[0];
          coordinates = {
              x: touch.clientX,
              y: touch.clientY
          };
        } else {
          if (touchEventsReceived) {
            return false;
          }
          coordinates =  {
              x: event.clientX,
              y: event.clientY
          };
        }

        startCoordinate = coordinates;

      });

      if (typeof sliderContainer === "string") {
        
        $(sliderContainer + " a").on("click", (event) => {
          
          if (!myImpetus.getPaused() && myImpetus.getDragCount() > 0) {
            event.preventDefault();
            return false;
          }

        });

        if ($(sliderContainer + " .featured-doelen__col a").length > 0) {

          $(sliderContainer + " .featured-doelen__col").on("click", (event) => {
            
            if (!myImpetus.getPaused() && myImpetus.getDragCount() > 0) {            
              event.preventDefault();
              return false;
            } else {

              if (event.target.tagName.toLowerCase() === 'a') {
                return;
              }
              event.preventDefault();
              event.stopPropagation();

              location.href = $(event.target).closest(".featured-doelen__col").find("a").attr("href");
            }
    
          });
        }
     
      } else {
        if ($(sliderContainer).find(".carousel-afbeeldingen__col a").length > 0) {

          $(sliderContainer).find(".carousel-afbeeldingen__col").on("click", (event) => {
            if (!myImpetus.getPaused() && myImpetus.getDragCount() > 0) {            
              event.preventDefault();
              event.stopPropagation();
              return false;
            } else {

              if (event.target.tagName.toLowerCase() === 'a') {
                return;
              }
              event.preventDefault();
              event.stopPropagation();
            }
    
          });
        }
      }

      let oldWidth : number = $(window).width();
      $(window).resize(function () {

        if (oldWidth != $(window).width()) {

          oldWidth = $(window).width();
          position = 0;
          
          ignoreImpetus = false;
          myImpetus.resume();
          currentPosition = 0;

          myImpetus.setValues(0, 0);
          self.setTotalWidth();
          myImpetus.setBoundX([-(self.totalWidth - $(self.slideTransform).innerWidth() - 5) , 0]);
          TweenMax.to(self.slideTransform, 0.2 , {x: position, ease: Power3.easeOut});

          slideWidth = $(self.slideElement).outerWidth(true);
          if (!!self.useParentWidhForSlideElement) {
            slideWidth = $(self.slideElement).parent().outerWidth(true);
          }

          self.updateControlsState(currentPosition, Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 )));
        }
      });
      



      if (self.controlLeft !== undefined) {
        $(self.controlLeft).on('click', (event) => {
          event.preventDefault();

          if ($(self.slideElement).length == 1) {
            return;
          }

          let slideWidth : number = $(self.slideElement).outerWidth(true);
          if (!!self.useParentWidhForSlideElement) {
            slideWidth = $(self.slideElement).parent().outerWidth(true);
          }
          
          currentPosition += slideWidth;
          if (currentPosition < -(self.totalWidth - $(self.slideTransform).innerWidth() - 10 )) {
            currentPosition = -(self.totalWidth - $(self.slideTransform).innerWidth() - 10);
          }
          if (currentPosition >= 0 ) {
            currentPosition = 0;
          }
          myImpetus.setValues(currentPosition, 0);
          self.updateControlsState(currentPosition, Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 )));
          TweenMax.to(self.slideTransform, 0.35 , {x: currentPosition, ease: Power1.easeInOut});
          return false;
        });  
      }

      if (self.controlRight !== undefined) {
        $(self.controlRight).on('click', (event) => {
          event.preventDefault();

          if ($(self.slideElement).length == 1) {
            return;
          }
          
          currentPosition -= slideWidth;
          if (currentPosition < Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 ))) {
            currentPosition = Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 ));
          }
          myImpetus.setValues(currentPosition, 0);
          self.updateControlsState(currentPosition, Math.ceil(-(self.totalWidth - $(self.slideTransform).innerWidth() - 10 )));
          TweenMax.to(self.slideTransform, 0.35 , {x: currentPosition, ease: Power1.easeInOut});
          return false;
        });  
      }


      $(document).on('click', '.page-slider__slide .joboverview__block-cta-button', (event) => {
        event.preventDefault();
        location.href = $(event.target).attr("href");
        return false;        
      });  
    }
  }
}


function setupPageSlider(sliderContainer : string, slideTransform : string, slideElement : string, controlLeft : string, controlRight : string, 
    useParentWidhForSlideElement: boolean = false, slideOnAllBreakPoints = false) {
  
      new PageSliderController(sliderContainer, slideTransform, slideElement, controlLeft, controlRight, 
    useParentWidhForSlideElement, slideOnAllBreakPoints);

}

function setupPageSliders(sliderContainer : string, slideTransform : string, slideElement : string, controlLeft : string, controlRight : string, 
  useParentWidhForSlideElement: boolean = false, slideOnAllBreakPoints = false) {

    $(sliderContainer).each((index, element) => {
      new PageSliderController($(element), 
        $(element).find(slideTransform), 
        $(element).find(slideElement), 
        $(element).next().find(controlLeft), 
        $(element).next().find(controlRight), 
      useParentWidhForSlideElement, slideOnAllBreakPoints);
    });
}

export function initPageSliders() {

  // if more sliders are added... then also modify hasPageSliders in PageSliderLoaderHelper.ts
  setupPageSlider(".featured-doelen__row-container", ".featured-doelen__row", ".featured-doelen__col", 
    ".featured-doelen__control-left",
    ".featured-doelen__control-right");

  setupPageSliders(".carousel-afbeeldingen__row-container", ".carousel-afbeeldingen__row", ".carousel-afbeeldingen__col", 
    ".carousel-afbeeldingen__control-left",
    ".carousel-afbeeldingen__control-right" , false, true);
 
  setupPageSlider(".featured-acties__scroll-container", ".featured-acties__actie-row-container", ".featured-acties__actie", 
    ".featured-acties__control-left",
    ".featured-acties__control-right", $(".featured-acties__layout-b").length > 0);

  setupPageSlider(".nieuwsoverzicht", ".nieuwsoverzicht__row-container", ".nieuwsoverzicht__item-container", 
    ".featured-acties__control-left",
    ".featured-acties__control-right", false, true);

  setupPageSlider(".eventscases", ".eventscases__row-container", ".eventscases__item-container", 
    ".featured-acties__control-left",
    ".featured-acties__control-right");

  $(".eventcases__meer-nieuws-laden").click(function(event) {
    event.preventDefault();
    let loop = 0;
    $(".eventscases__item-container.hidden").each((index, item) => {
      if (loop < 10) {
        $(item).removeClass("hidden");
        loop++;
      }
    });
    if ($(".eventscases__item-container.hidden").length == 0) {
      $(".eventcases__meer-nieuws-laden").remove();
    }
    return false;
  });

  if ($(".testimonial__container-wrapper").length > 0) {
    setupPageSlider(".testimonial__container-column", ".testimonial__container", ".testimonial__item", 
      "",
      "");
  } 

}

PluginManager.registerPlugin('pageslider', initPageSliders);
EventManager.subscribe(EVENT_PAGESLIDER_ITEMS_LOADED, initPageSliders);
